<template>
  <div
    :id="data.id"
    v-lazy-background="getAssetUrl(data.image)"
    class="bg-cover bg-center bg-no-repeat py-[76px] text-center text-white md:py-36"
  >
    <div class="container">
      <UiSectionTitle
        v-if="data.title"
        :title="data.title"
        tag="h1"
        class="title mb-6 text-xl uppercase md:text-6xl"
      />

      <nav v-if="data.categories" class="flex flex-wrap justify-center gap-2">
        <UiLink
          v-for="(item, i) in data.categories"
          :key="i"
          :to="item.link"
          class="title flex min-h-8 items-center justify-center rounded-full border-[1px] border-white px-4 py-2.5 text-xs uppercase leading-none tracking-[0.12em] text-white"
        >
          {{ item.text }}
        </UiLink>
      </nav>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useMediaAsset } from '~/composables';

interface Props {
  data?: any;
}

const { getAssetUrl } = useMediaAsset();

withDefaults(defineProps<Props>(), {
  data: () => ({}),
});
</script>
